// extracted by css-extract-rspack-plugin
var _1 = "ai-attribute-tag-Pu0SFs";
var _2 = "ai-attribute-tag-interactive-poZmct";
var _3 = "ai-attribute-tag-Pu0SFs";
var _4 = "ai-attribute-tag-interactive-poZmct";
var _5 = "description-G_qnj7";
export { _1 as "ai-attribute-tag", _2 as "ai-attribute-tag-interactive", _3 as "aiAttributeTag", _4 as "aiAttributeTagInteractive", _5 as "description" }
